import { RootState } from "redux/rootReducer";

export const selectIsLoadingExchangeList = (state: RootState) =>
  state.exchangeList.loading;
export const selectExchangeListErrorMessage = (state: RootState) =>
  state.exchangeList.error;
export const exchangeListDataResponse = (state: RootState) =>
  state.exchangeList.exchangeListResponse;
